import { createGetChannel } from "@src/utils/apis/requestRX";
import { Fetch, ResponseData } from "@src/utils/apis/typeRX";

// 证据包查询参数
export interface claimsNoParams {
    claimsNo: string;
    smsCode: string;
}

// 证据包查询
export const queryByClaimsNo: Fetch<claimsNoParams, ResponseData<any>> = createGetChannel("/api/reexuan-blockchain-service/explorer/file/queryByClaimsNo");


